import { ProfileTypeEnumerator } from 'app/core';

export const accessControlList: any = {
  canView: [
    ProfileTypeEnumerator.ADMIN,
    ProfileTypeEnumerator.SCHOOL_ADMIN,
    ProfileTypeEnumerator.TEACHER,
    ProfileTypeEnumerator.ADVISER,
    ProfileTypeEnumerator.ATTENDANT,
  ],
};
